import { Text } from 'preact-i18n';
import { VerificationStatus } from '../../types/verification-status';
import { h } from 'preact';
import { ReviewedIcon } from '../icons/reviewed-icon';
import * as styles from './panel.scss';
import { clsx } from 'clsx';

interface Props {
  verificationStatus: VerificationStatus;
}
export const AccuracyLabel = ({ verificationStatus }: Props): h.JSX.Element => {
  let component = null;
  switch (verificationStatus) {
    case VerificationStatus.Automatic:
      component = (
        <div className={clsx(styles.accuracyLabel, styles.accuracyLabelAutomatic)}>
          <Text id="taxonomyTranscript.automaticallyGenerated">Automatically Generated</Text>
        </div>
      );
      break;
    case VerificationStatus.Verified:
      component = (
        <div className={styles.accuracyLabel}>
          <ReviewedIcon />
          <span className={clsx(styles.accuracyLabelVerified, styles.verifiedText)}>
            <Text id="taxonomyTranscript.humanVerified">Reviewed for Accuracy</Text>
          </span>
        </div>
      );
      break;
  }

  return <div>{component}</div>;
};
